/*
 * @Author: zerui.yao
 * @Date: 2022-11-28 10:52:12
 * @LastEditors: zerui.yao
 * @LastEditTime: 2023-06-01 14:06:58
 * @FilePath: /fed-authority/src/router/basic.js
 * @Description:
 */
import loaded from '@/utils/util.import';

export default [
  // 默认页面
  {
    path: '/home',
    name: 'home',
    meta: {
      title: 'common.pageTitle.home',
      tabId: 'home',
      icon: 'home',
      closable: false,
    },
    component: loaded('Home'),
  },
  // 刷新页面 必须保留
  {
    path: '/refresh',
    hidden: true,
    component: loaded('system/function/refresh'),
  },
];
